import React from 'react';
import WrapComponent from './WrapComponent';
import Select from '../form/select/select';

class MultiLevelSelectOne extends React.Component{
    render() {
        let { form, api_name, default_value, is_required} = this.props;

        const { getFieldProps } = form;
        let fieldProps = getFieldProps(api_name + '_custom', {
            initialValue: default_value,
            validate: [{
                trigger: 'onChange',
                rules: [{
                    required: is_required,
                    message: $st(`paas.smart.form.isrequired`)
                }]
            }]
        });

        let secondProps = getFieldProps(api_name, {
            validate: [{
                trigger: 'onChange',
                rules: [{
                    required: true,
                    message: $st(`paas.smart.form.isrequired`)
                }]
            }]
        });

        let value = form.getFieldValue(api_name + '_custom');
        let options = this.props.options;
        let levelOptions = null;
        for(let option of options){
            if (option.value === value){
                levelOptions = option.child_options;
                break;
            }
        }

        return (
            <div>
                <Select {...this.props} {...fieldProps} />
                {levelOptions && <Select {...this.props} {...secondProps} options={levelOptions}/>}
            </div>
        )
    }

}

export default WrapComponent(MultiLevelSelectOne);


// WEBPACK FOOTER //
// ./src/component/MultiLevelSelectOne.js